<template>
	<div id="app">
		<vue-snotify></vue-snotify>
		<nav-header></nav-header>

		<!-- content -->
		<router-view style="margin: 100px auto"/>

		<!-- footer -->
		<b-navbar toggleable="md" type="light" variant="light" fixed='bottom' >
			<b-navbar-brand href="https://www.unil.ch/bix"  tag='h4'>© BIƆC - UNIL & EPFL {{year}}</b-navbar-brand>
		</b-navbar>

</div>
</template>


<script>

import navHeader from '@/components/navheader'

export default {
	components: { navHeader },
	name: 'App',
	computed:{
		year () {
			return new Date().getFullYear();
		}
	}
}
</script>


<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
/*  text-align: center;*/
  color: #2c3e50;
}

.pointer{
	cursor:pointer;
}
.ban{
	cursor:not-allowed;
}
.nocursor > a{
	cursor:default !important;
}
.uppercase{
	text-transform:uppercase;
}

.navbar_link >a{
	color:white;
}
.nav-link > a{
	color:white;
}

.perso{
/*	background-color:#B1E2CD !important;*/
	background-color:#C1E8D7 !important;
}

.has-error{
	color:#dc3545;
}
.has-error input{
	border:1px solid #dc3545 !important;
}
.has-error input:focus{
	border:1px solid #dc3545;
	box-shadow:0 0 0 0.15rem #F8E6E0 !important;
}
.has-error select{
	border:1px solid #dc3545 !important;
}
.has-error select:focus{
	border:1px solid #dc3545;
	box-shadow:0 0 0 0.15rem #F8E6E0 !important;
}

.ddright {
	text-align:right;
	font-weight:bold;
}

.has-error small{
	float:left;
	margin-top:5px;
	font-style:italic;
	font-size:11px;
}

a.navbar-brand {
	color: #CCC;
	font-size: 11pt;
}
</style>
